import DropzoneContent from './DropzoneContent.component';

export default DropzoneContent;